import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Room } from '../models/models';

import { InfrastructureService } from './infrastructure.service';

@Injectable({
  providedIn: 'root',
})
export class RoomService extends InfrastructureService<Room> {
  protected readonly endpoint: string = '/Rooms';

  constructor(protected http: HttpClient) {
    super(http);
  }

}
